<div class="modal-content bary-add-or-update-address">
  <div class="modal-header">
    <i aria-label="Close" (click)="handleClick({ close: true })" class="close pull-right align-middle fas fa-times"> </i>
    <p class="modal-title h4" jhiTranslate="ADD_OR_UPDATE_ADR.TITLE"></p>
  </div>
  <div class="modal-body">
    <div class="row align-items-center">
      <div class="col-12">
        <jhi-bary-title
          titleClass="bold text-dark mb-0"
          [tooltip]="'ADD_OR_UPDATE_ADR.LIMITED_QUANTITY.TOOLTIP' | translate"
          titleKey="ADD_OR_UPDATE_ADR.LIMITED_QUANTITY.TITLE"
        ></jhi-bary-title>
      </div>
      <div class="col-12 col-md-6 col-xl-4">
        <jhi-bary-input-select
          [control]="transportExtraConditionForm.controls.adrIsLimitedQuantity"
          [options]="[
            { label: 'WORD.YES' | translate, value: true },
            { label: 'WORD.NO' | translate, value: false }
          ]"
          [label]="'ADD_OR_UPDATE_ADR.LIMITED_QUANTITY.LABEL' | translate"
        >
        </jhi-bary-input-select>
      </div>
    </div>
    <div class="row pt-2 align-items-center" *ngIf="transportExtraConditionForm.controls.adrIsLimitedQuantity.value === false">
      <div class="col-12">
        <jhi-bary-title titleClass="bold text-dark mb-0" titleKey="ADD_OR_UPDATE_ADR.UN_NUMBER.TITLE"></jhi-bary-title>
      </div>
      <div class="col-12 col-md-4 col-xl-3">
        <jhi-bary-input-autocomplete
          [label]="'ADD_OR_UPDATE_ADR.UN_NUMBER.LABEL' | translate"
          [control]="transportExtraConditionForm.controls.adrCodeUN"
          [options]="refADRUNOptions"
          (selectEvent)="getByCriteria(transportExtraConditionForm, transportExtraConditionForm.controls.adrCodeUN.value, 0)"
        ></jhi-bary-input-autocomplete>
      </div>
      <div
        class="col-12 col-md-8 col-xl-9"
        *ngIf="transportExtraConditionForm.controls.adrCodeUN.value && filteredDescriptionOptions.get(0) && filteredDescriptionOptions.get(0)!.length > 0"
      >
        <jhi-bary-input-select
          [label]="'ADD_OR_UPDATE_ADR.UN_NUMBER.DESCRIPTION.LABEL' | translate"
          [control]="transportExtraConditionForm.controls.adrDescription"
          [options]="filteredDescriptionOptions.get(0)!"
          (selectEvent)="
            getByCriteria(transportExtraConditionForm, transportExtraConditionForm.controls.adrCodeUN.value, transportExtraConditionForm.controls.adrDescription.value)
          "
        ></jhi-bary-input-select>
      </div>
    </div>
    <div class="row pt-2 align-items-center" *ngIf="transportExtraConditionForm.controls.adrIsLimitedQuantity.value === false">
      <div class="col-12">
        <jhi-bary-title titleClass="bold text-dark mb-0" titleKey="ADD_OR_UPDATE_ADR.UN_NUMBER.PACKING.TITLE"></jhi-bary-title>
      </div>
      <div class="col-12 col-md-4 col-xl-4">
        <jhi-bary-input-select
          [label]="'ADD_OR_UPDATE_ADR.UN_NUMBER.PACKING.LABEL' | translate"
          [control]="transportExtraConditionForm.controls.adrPacking"
          [options]="packingOptions"
        ></jhi-bary-input-select>
      </div>
      <div
        class="col-12 col-md-4 col-xl-4"
        *ngIf="transportExtraConditionForm.controls.adrCodeUN.value && filteredDescriptionOptions.get(0) && filteredDescriptionOptions.get(0)!.length > 0"
      >
        <jhi-bary-input-number
          [label]="'ADD_OR_UPDATE_ADR.UN_NUMBER.PACKING_NUMBER.LABEL' | translate"
          [control]="transportExtraConditionForm.controls.adrPackingNumber"
        ></jhi-bary-input-number>
      </div>
      <div class="col-12 col-md-4 col-xl-4" *ngIf="transportExtraConditionForm.controls.adrDescription.value && hasPackingGroup()">
        <jhi-bary-input-select
          [label]="'ADD_OR_UPDATE_ADR.UN_NUMBER.PACKING_GROUP.LABEL' | translate"
          [control]="transportExtraConditionForm.controls.adrPackingGroup"
          [options]="getPackingGroup()"
        ></jhi-bary-input-select>
      </div>
    </div>
    <div class="row pt-4 align-items-center">
      <div class="col-12">
        <jhi-bary-title titleClass="bold text-dark mb-0" titleKey="ADD_OR_UPDATE_ADR.NET_WEIGHT.TITLE"></jhi-bary-title>
      </div>
      <div class="col-12 col-md-6 col-xl-4">
        <jhi-bary-input-number [label]="'ADD_OR_UPDATE_ADR.NET_WEIGHT.LABEL' | translate" [control]="transportExtraConditionForm.controls.adrNetWeight"></jhi-bary-input-number>
      </div>
    </div>
    <div class="row align-items-center pt-2" *ngIf="transportExtraConditionForm.controls.adrIsLimitedQuantity.value === false">
      <div class="col-12">
        <jhi-bary-title titleClass="bold text-dark" titleKey="ADD_OR_UPDATE_ADR.SPECIFICATIONS.TITLE"></jhi-bary-title>
      </div>
      <div class="col-12 col-md-auto">
        <jhi-bary-input-checkbox
          [label]="'ADD_OR_UPDATE_ADR.SPECIFICATIONS.IS_DANGEROUS.LABEL' | translate"
          [control]="transportExtraConditionForm.controls.adrIsDangerousForEnvironment"
        ></jhi-bary-input-checkbox>
      </div>
      <div class="col-12 col-md-auto">
        <jhi-bary-input-checkbox
          [tooltip]="'ADD_OR_UPDATE_ADR.SPECIFICATIONS.IS_WASTE.TOOLTIP' | translate"
          [label]="'ADD_OR_UPDATE_ADR.SPECIFICATIONS.IS_WASTE.LABEL' | translate"
          [control]="transportExtraConditionForm.controls.adrIsWaste"
        ></jhi-bary-input-checkbox>
      </div>
    </div>
    <div class="row align-items-center">
      <div class="col-12 col-md-6 col-xl-4" *ngIf="transportExtraConditionForm.controls.adrIsWaste.value">
        <jhi-bary-input-text
          [label]="'ADD_OR_UPDATE_ADR.SPECIFICATIONS.IS_WASTE.BSD_CODE.LABEL' | translate"
          [control]="transportExtraConditionForm.controls.adrWasteBsdCode"
        ></jhi-bary-input-text>
      </div>
    </div>
  </div>

  <!--Footer-->
  <div class="modal-footer justify-content-end">
    <jhi-bary-button [outline]="true" color="primary" class="mr-2" [label]="'BTN.CANCEL' | translate" (clickEvent)="handleClick({ cancel: true })"></jhi-bary-button>
    <jhi-bary-button (clickEvent)="handleSubmit({ submit: true, value: transportExtraConditionForm })" [label]="'BTN.ADD' | translate" color="primary"></jhi-bary-button>
  </div>
</div>
